{
  "REGISTER": {
    "TRY_WOOT": "Create an account",
    "GET_STARTED": "Get started with Chatwoot",
    "TITLE": "Registrovat se",
    "TESTIMONIAL_HEADER": "All it takes is one step to move forward",
    "TESTIMONIAL_CONTENT": "You're one step away from engaging your customers, retaining them and finding new ones.",
    "TERMS_ACCEPT": "By creating an account, you agree to our <a href=\"https://www.chatwoot.com/terms\">T & C</a> and <a href=\"https://www.chatwoot.com/privacy-policy\">Privacy policy</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Sign up with Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Company name",
      "PLACEHOLDER": "Enter your company name. eg: Wayne Enterprises",
      "ERROR": "Company name is too short"
    },
    "FULL_NAME": {
      "LABEL": "Celé jméno",
      "PLACEHOLDER": "Zadejte celé jméno. např.: Jan Novák",
      "ERROR": "Celé jméno je příliš krátké"
    },
    "EMAIL": {
      "LABEL": "Pracovní e-mail",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Please enter a valid work email address"
    },
    "PASSWORD": {
      "LABEL": "Heslo",
      "PLACEHOLDER": "Heslo",
      "ERROR": "Heslo je příliš krátké",
      "IS_INVALID_PASSWORD": "Heslo by mělo obsahovat alespoň jedno velké písmeno, jedno malé písmeno, jedno číslo a jeden speciální znak",
      "REQUIREMENTS_LENGTH": "At least 6 characters long",
      "REQUIREMENTS_UPPERCASE": "At least one uppercase letter",
      "REQUIREMENTS_LOWERCASE": "At least one lowercase letter",
      "REQUIREMENTS_NUMBER": "At least one number",
      "REQUIREMENTS_SPECIAL": "At least one special character"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Potvrzení hesla",
      "PLACEHOLDER": "Potvrzení hesla",
      "ERROR": "Hesla se neshodují."
    },
    "API": {
      "SUCCESS_MESSAGE": "Registration Successful",
      "ERROR_MESSAGE": "Nelze se připojit k Woot serveru, opakujte akci později"
    },
    "SUBMIT": "Create account",
    "HAVE_AN_ACCOUNT": "Máte již účet?",
    "VERIFY_EMAIL": {
      "TITLE": "Check your inbox",
      "DESCRIPTION": "We sent a verification link to {email}. Click the link to verify your email and get started.",
      "RESEND": "Resend verification email",
      "RESEND_SUCCESS": "Verification email sent. Please check your inbox.",
      "RESEND_ERROR": "Could not send verification email. Please try again."
    }
  }
}
